import { DateTime } from 'luxon';

const TIMEZONE_MAP = {
  'Eastern Time (ET)': 'America/New_York',
  'Pacific Time (PT)': 'America/Los_Angeles',
  'Mountain Time (MT)': 'America/Denver',
  'Central Time (CT)': 'America/Chicago',
  'Central European Time (CET)': 'Europe/Paris',
  'Greenwich Mean Time (GMT)': 'Europe/London',
  'India Standard Time (IST)': 'Asia/Kolkata',
  'Japan Standard Time (JST)': 'Asia/Tokyo',
  'Australian Eastern Time (AET)': 'Australia/Sydney',
  'Hawaii Time (HT)': 'Pacific/Honolulu',
  'Alaska Time (AKT)': 'America/Anchorage',
};

export function timezoneLabelToIana(label) {
  if (!label) return 'America/New_York';
  if (TIMEZONE_MAP[label]) return TIMEZONE_MAP[label];
  const lower = String(label).toLowerCase().trim();
  if (lower.includes('beijing') || String(label).includes('北京')) return 'Asia/Shanghai';
  if (String(label).includes('/')) return label;
  return 'America/New_York';
}

/**
 * Build lesson-plan slot objects from Calendly API records ({ utc, display, tier }).
 * Dates/times are derived from the UTC instant — no string parsing of month/day.
 * Returns null if the match has no records (caller uses legacy string path).
 */
export function parseSlotsFromCalendlyRecords(match, studentTimezoneLabel) {
  const records = match?.all_coach_slot_records;
  if (!Array.isArray(records) || records.length === 0) return null;

  const zone = timezoneLabelToIana(studentTimezoneLabel);
  const parsed = [];
  const seenUtc = new Set();

  for (const rec of records) {
    const utc = rec.utc;
    if (!utc || seenUtc.has(utc)) continue;
    seenUtc.add(utc);
    const dt = DateTime.fromISO(utc, { setZone: true }).setZone(zone);
    if (!dt.isValid) continue;

    const d = dt.toJSDate();
    const tier = rec.tier || 'all';
    const displayRaw = String(rec.display || '').trim();
    const cleanDisplay = displayRaw.replace(/\s*\(.*?\)\s*$/, '').trim();
    const dow = dt.weekday % 7;

    parsed.push({
      date: d,
      dayOfWeek: dow,
      dayName: dt.toFormat('EEEE'),
      hours24: dt.hour,
      minutes: dt.minute,
      timeStr: dt.toFormat('h:mm a'),
      display: cleanDisplay || dt.toFormat("EEE, MMM d 'at' h:mm a"),
      original: displayRaw || dt.toFormat("EEE, MMM d 'at' h:mm a"),
      utc,
      isExact: tier === 'exact',
      isNearby: tier === 'nearby',
      luxonDT: dt,
      dayShort: dt.toFormat('EEE'),
      dateStr: dt.toFormat('MMM d'),
    });
  }

  if (parsed.length === 0) return null;
  parsed.sort((a, b) => a.date - b.date);
  return parsed;
}
